import PropTypes from 'prop-types';
import './MockWindow.css';

/**
 * Окно-мокап: рамка браузера вокруг показываемого экрана.
 *
 * ## Зачем атом, а не рамка в каждом месте
 *
 * На странице чатов таких окон ДВА рядом: слева переписка покупателя, справа
 * инбокс команды. Хром, нарисованный дважды, разъехался бы при первой же
 * правке — а он и есть то, что делает два разных блока одной историей.
 *
 * Приём взят с корпоративного сайта (`shiftgears_website/.../AdminMockup.tsx`),
 * чтобы витрина и сайт показывали продукт одинаково.
 *
 * ## `label`
 *
 * Подпись в хроме отвечает на вопрос «что это за окно». У чата туда уходит
 * логотип мессенджера: без него переписка в рамке — просто переписка, и
 * непонятно, где она идёт.
 *
 * Файл в `pages/shared/`, поэтому его CSS не инлайнится в Shadow DOM дилера
 * (`bootstrap.jsx` берёт глоб `components/**` и именной список `pages/*.css`).
 *
 * @param {object} props
 * @param {React.ReactNode} [props.label] — что показано в окне.
 * @param {React.ReactNode} props.children
 * @param {string} [props.className]
 */
export const MockWindow = ({ label = null, children, className = '', ...rest }) => (
  <div className={`mock-window${className ? ` ${className}` : ''}`} {...rest}>
    <div className="mock-window__chrome">
      {/* Точки декоративные: они говорят «это окно», и озвучивать их нечем. */}
      <span className="mock-window__dots" aria-hidden="true">
        <span className="mock-window__dot" />
        <span className="mock-window__dot" />
        <span className="mock-window__dot" />
      </span>
      {label && <span className="mock-window__label">{label}</span>}
    </div>
    {children}
  </div>
);

MockWindow.propTypes = {
  label: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default MockWindow;
